import { Grid } from "@material-ui/core"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import {
  StyledDetailHeader,
  StyledDetailLocation,
  StyledDetailSubheader,
  StyledDetailSubheaderContent,
} from "./MapTypography"
import { Image } from "react-image-and-background-image-fade"
import v2_food_logo from "../../images/v2-food-logo.png"
import zero_hunger from "../../images/zero-hunger.png"
import responsible_consumption from "../../images/responsible-consumption.png"
import climate_action from "../../images/climate-action.png"
import life_on_land from "../../images/life-on-land.png"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"

const StyledLogoWrapper = styled.div`
  width: 50%;
  margin-bottom: 5%;

  ${breakpoint.md} {
    width: 40%;
  }
`

const StyledInvestmentThemeWrapper = styled.div`
  width: 100%;
  border-bottom: 2px solid #0f6494;
  padding-top: 8px;
  padding-bottom: 8px;

  ${breakpoint.lg} {
    border-bottom: 3px solid #0f6494;
    padding-top: 12px;
    padding-bottom: 12px;
  }
`

const V2FoodMapDetailMobile = () => {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <StyledLogoWrapper>
            <Image
              src={v2_food_logo}
              width="692px"
              height="304px"
              isResponsive
              disableLoader
              alt="V2 Food"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </StyledLogoWrapper>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <div style={{ marginBottom: "1%" }}>
          <StyledDetailHeader>Plant-Based Meat</StyledDetailHeader>
        </div>
      </Grid>
      <Grid item xs={12}>
        <StyledDetailLocation>Based in Australia</StyledDetailLocation>
      </Grid>
      <Grid container>
        <Grid item xs={12} container alignItems="center">
          <StyledInvestmentThemeWrapper>
            <Grid item xs={12}>
              <div style={{ marginBottom: "1%" }}>
                <StyledDetailSubheader>Investment Theme</StyledDetailSubheader>
              </div>
            </Grid>
            <Grid item xs={12}>
              <StyledDetailSubheaderContent>
                Sustainable Food & Agriculture
                <br />
                Climate & Water Solutions
              </StyledDetailSubheaderContent>
            </Grid>
          </StyledInvestmentThemeWrapper>
        </Grid>
        <Grid item xs={12}>
          <StyledDetailSubheader style={{ marginTop: "16px" }}>
            About the Company
          </StyledDetailSubheader>
          <StyledDetailSubheaderContent>
            Producer of plant-based meat using protein extracted from legumes.
          </StyledDetailSubheaderContent>
          <StyledDetailSubheader style={{ marginTop: "16px" }}>
            Impact Thesis
          </StyledDetailSubheader>
          <StyledDetailSubheaderContent>
            Accelerating consumers’ transition to a more plant-rich diet and
            reducing GHG emissions, water use and land use.
          </StyledDetailSubheaderContent>
        </Grid>
      </Grid>
      <div style={{ width: "100%", marginTop: "10%" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Image
              src={zero_hunger}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="zero hunger"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
          <Grid item xs={3}>
            <Image
              src={responsible_consumption}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="responsible consumption and production"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
          <Grid item xs={3}>
            <Image
              src={climate_action}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="climate action"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
          <Grid item xs={3}>
            <Image
              src={life_on_land}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="life on land"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default V2FoodMapDetailMobile
